import { PrismicRichText } from '@prismicio/react';
import IconArrowDown from '@remote-com/norma/icons/arrow-down.svg';
import { Hero as HeroComponent } from 'remote-com-shared/components/Hero';
import styled from 'styled-components';

import BgIllustration from './assets/hero.png';

import { transformProperties } from '@/src/domains/prismic/helpers';
import { ScrollButton } from '@/src/views/G2LeaderPage/HeroSlice';
import { Header } from '@/src/views/SharedEvents/Header';

const Hero = styled(HeroComponent)`
  font-family: var(--typography-fontBossa);
  background-image: url(${BgIllustration.src});
  background-size: cover;
  background-position: right;

  ${ScrollButton} {
    font-family: var(--typography-fontBrand);

    svg {
      padding-left: 12px;
    }
  }
`;

export function HeroSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, readMore } = primary;

  return (
    <>
      <Header />
      <Hero
        title={<PrismicRichText field={title} />}
        actions={
          <ScrollButton href="#onboarding">
            {readMore || 'Read more'} <IconArrowDown />
          </ScrollButton>
        }
        preview="0vh"
      />
    </>
  );
}
